import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 1140px;
  margin: 0 auto;
  display: block;

  padding: 0 8px;

  ${(props) => props.theme.media.desktop} {
    padding: 0;
  }
`;
